import { ImportCandidate, ProductLink } from "../types/domain";

function tukiosProductLinks(obituaryUrl: string): ProductLink[] {
  return [
    { type: "flowers", label: "Send Flowers", subtitle: "Order flowers for the family", url: `${obituaryUrl}/flowers` },
    { type: "cards", label: "Send a Card", subtitle: "Show your sympathy to the family", url: `${obituaryUrl}/cards` },
    { type: "gifts", label: "Plant Trees", subtitle: "In remembrance", url: `${obituaryUrl}/gifts` },
  ];
}

export const pendingCases: ImportCandidate[] = [
  {
    decedentName: "Margaret Rose Callahan",
    dob: "1948-06-15",
    dod: "2026-03-26",
    obituaryUrl: "https://www.monarchfuneralhome.com/obituary/margaret-callahan",
    photoUrl: "https://www.monarchfuneralhome.com/fh_live/16500/16565/images/obituaries/placeholder.png",
    confidence: "high",
    productLinks: tukiosProductLinks("https://www.monarchfuneralhome.com/obituary/margaret-callahan"),
    services: [
      {
        title: "Visitation",
        type: "visitation",
        date: "2026-03-31",
        time: "14:00",
        endTime: "16:00",
        venue: "Monarch Funeral Home & Cremation Services",
        address: "2950 N State Rd 7, Margate, FL 33063",
      },
      {
        title: "Funeral Service",
        type: "funeral",
        date: "2026-03-31",
        time: "16:00",
        endTime: "17:00",
        venue: "Monarch Funeral Home & Cremation Services",
        address: "2950 N State Rd 7, Margate, FL 33063",
        livestreamUrl: "https://www.hdezwebcast.com/show/margaret-callahan",
      },
    ],
  },
  {
    decedentName: "Robert James Chen",
    dob: "1955-03-22",
    dod: "2026-03-27",
    obituaryUrl: "https://www.monarchfuneralhome.com/obituary/robert-chen",
    photoUrl: "https://www.monarchfuneralhome.com/fh_live/16500/16565/images/obituaries/placeholder2.png",
    confidence: "high",
    productLinks: tukiosProductLinks("https://www.monarchfuneralhome.com/obituary/robert-chen"),
    services: [
      {
        title: "Memorial Service",
        type: "memorial_service",
        date: "2026-04-01",
        time: "11:00",
        endTime: "12:00",
        venue: "Monarch Funeral Home & Cremation Services",
        address: "2950 N State Rd 7, Margate, FL 33063",
      },
      {
        title: "Reception",
        type: "reception",
        date: "2026-04-01",
        time: "12:00",
        endTime: "14:00",
        venue: "Monarch Funeral Home & Cremation Services",
        address: "2950 N State Rd 7, Margate, FL 33063",
      },
    ],
  },
];
